import { supabase } from '../supabase';

// One-round-trip detail for the CRM opportunity modal (linked ids + field quote
// + project + first/last activity), backed by the get_opportunity_detail RPC.

export interface OpportunityActivityLite {
  activity_type: string;
  activity_data: any;
  created_at: string;
}

export interface OpportunityDetail {
  proposal_id: string | null;
  booking_id: string | null;
  field_quote_id: string | null;
  field_quote_status: string | null;
  field_quote_is_measurement: boolean | null;
  project_id: string | null;
  project_title: string | null;
  project_status: string | null;
  first_activity: OpportunityActivityLite | null;
  last_activity: OpportunityActivityLite | null;
}

export async function getOpportunityDetail(
  businessId: string,
  opportunityId: number,
): Promise<OpportunityDetail | null> {
  if (!supabase) return null;
  const { data, error } = await supabase.rpc('get_opportunity_detail', {
    p_business_id: businessId,
    p_opportunity_id: opportunityId,
  });
  if (error) throw error;
  const row = Array.isArray(data) ? data[0] : data;
  return (row as OpportunityDetail) ?? null;
}
